import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IUserHistory } from '../models/response/getUserListResponseModel'

export class HistoryUserApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/user/listHistoryById',
      requesterInfo,
    })
  }

  public async historyByID(request: number): Promise<IUserHistory[]> {
    return await this.postAsync<IUserHistory[]>(request)
  }
}
